const auth = localStorage.getItem("vn_associates_insurance_admin")
const initialState = {
    auth: auth ? JSON.parse(auth) : {},
    isAuthenticated: auth ? Object.keys(auth).length ? true : false : false,
    loading: false,
    erors: {},
    changePasswordStatus: null,
}

const AuthReducer = (state = initialState, action) => {
    switch (action.type) {
        case "LOGIN_PENDING":
            return { ...state, loading: true }
        case "LOGIN_FULFILLED":
            return { ...state, loading: false, auth: action.payload, isAuthenticated: true }
        case "LOGIN_FAILED":
            //toast.error(action.payload?.message)
            return { ...state, loading: false, errors: action.payload }
        case "LOG_OUT_FULFILLED":
            return { ...state, auth: {}, isAuthenticated: false }
        case "CHANGE_PASSWORD_PENDING":
            return { ...state, loading: true, changePasswordStatus: null }
        case "CHANGE_PASSWORD_FULFILLED":
            return { ...state, loading: false, changePasswordStatus: action.payload }
        case "CHANGE_PASSWORD_REJECTED":
            return { ...state, loading: false, changePasswordStatus: { success: false, ...action.payload } }
        case "CLEAR_CHANGE_PASSWORD_STATUS":
            return { ...state, changePasswordStatus: null }
        default:
            return state
    }
}

export default AuthReducer